import { render, staticRenderFns } from "./FiltroExibirProdutosInativos.vue?vue&type=template&id=4fbe75a8"
import script from "./FiltroExibirProdutosInativos.vue?vue&type=script&lang=js"
export * from "./FiltroExibirProdutosInativos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports